export const defaultConfig = {
    apiUrl: "http://localhost:9000/"
};

export const dynamicConfiguracao = "config.json";